import { ActivatedRouteSnapshot, ResolveFn, Route } from '@angular/router';
import { inject } from '@angular/core';
import { AbrechnungenService } from './abrechnungen.service';
import { mgsIconsResolver } from '../../mgs-svg-icon.helper';

import {
  ILeistungAbrechnungenParams,
  MgsRole,
  ROLE_MGS_ARZT,
  ROLE_MGS_BUCHUNG,
  ROLE_MGS_KIDS,
  ROLE_MGS_SPOWI,
  ROLE_MGS_USER_FOR_KIDS_TERMIN
} from '@mng/mgs-lib';
import { LEISTUNG_ABRECHNUNGEN_PATH, LEISTUNG_ABRECHNUNGEN_TITLE } from '../../mgs-path-defs';
import { programmResolver } from '../../programm/programm.resolver';
import { mgsExclusionRoleGuard } from '../../mgs-guards';
import { PartnerAuswahlService } from '../../partner/partner-auswahl/partner-auswahl.service';
import { AuthStateFacade } from '../../auth/auth-state.facade';
import { PartnerService } from '../../partner/partner.service';
import { partnerResolver } from '../../partner/partner.resolver';

const abrechnungenResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot) => {
  const abrechnungenService = inject(AbrechnungenService);
  const authState = inject(AuthStateFacade);
  const partnerService = inject(PartnerService);
  const partnerAuswahlService = inject(PartnerAuswahlService);

  const params: ILeistungAbrechnungenParams = abrechnungenService.state().params;

  if (authState.isAdmin() || authState.isAbrechnungUser()) {
    await partnerService.resolvePartnerList();

    const partnerId = partnerAuswahlService.partnerIdErmitteln(route);
    if (partnerId) {
      const updatedParams: ILeistungAbrechnungenParams = { ...params, partnerId };
      return abrechnungenService.ermittleAbrechnungen(updatedParams);
    } else {
      abrechnungenService.resetAbrechnungen();
    }
  } else {
    return abrechnungenService.ermittleAbrechnungen();
  }
};
export const abrechnungenRolesForExclusion: MgsRole[] = [
  ROLE_MGS_KIDS,
  ROLE_MGS_USER_FOR_KIDS_TERMIN,
  ROLE_MGS_BUCHUNG,
  ROLE_MGS_ARZT,
  ROLE_MGS_SPOWI
];

export const abrechnungenRoute: Route = {
  path: LEISTUNG_ABRECHNUNGEN_PATH,
  title: LEISTUNG_ABRECHNUNGEN_TITLE,
  loadComponent: () => import('./abrechnungen.component'),
  resolve: {
    abrechnungen: abrechnungenResolver,
    partner: partnerResolver,
    programme: programmResolver,
    icons: mgsIconsResolver
  },
  canActivate: [mgsExclusionRoleGuard(abrechnungenRolesForExclusion)]
};
